import { useState, useEffect } from "react";
import { IServerSettingsProp } from "../Interfaces";
import { Plugin } from "../Plugin";
import { Feedback } from "../../Popup";

// const sdk = sdkInstance;

export const ServerSettingsPageComponent = (props: IServerSettingsProp) => {
  const [state, setState] = useState(props.serverSettings);
  const [allUsersFeedback, setAllUsersFeedback] = useState<Feedback[]>([]);

  const config = new Plugin().getConfig();
  // const matrixSession = sdk.matrixSession.getUser();
  // const users = sdk.matrixSession.serverConfig.allUsers;

  useEffect(() => {
    // @ts-ignore
    restConnection.getServer("user").then((users) => {
      let newFeedbacks = [];
      for (let user of users.user) {
        user.userSettingsList.forEach((userSetting) => {
          if (userSetting.key === config.customerSettingsPage.settingName) {
            let settingValue = JSON.parse(userSetting.value);
            for (let feedback of settingValue.feedbacks) {
              newFeedbacks.push(feedback);
            }
          }
        });
      }
      setAllUsersFeedback(newFeedbacks);
    });
  }, []);

  return (
    <table
      className="table table-striped table-bordered table-hover"
      style={{ width: "70vw" }}
    >
      <thead>
        <tr>
          <th style={{ width: "20%" }}>Who</th>
          <th style={{ width: "20%" }}>When</th>
          <th style={{ width: "5%" }}>CSAT</th>
          <th style={{ width: "5%" }}>NPS</th>
          <th>Comment</th>
        </tr>
      </thead>

      <tbody>
        {allUsersFeedback.map((feedback, index) => (
          <tr key={index}>
            <td>{feedback.user}</td>
            <td>{feedback.submitDate}</td>
            <td>{feedback.csat}</td>
            <td>{feedback.nps}</td>
            <td>{feedback.feedback}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};
